import { sha256 } from 'js-sha256';
import * as types from '../constants/ActionTypes';
import {WEB} from '../constants/SalesChannels';

const CUSTOMER_INFORMATION_CATEGORY = 'Book-Personalinfo';
const SERVICES_CATEGORY = 'Book-Options';
const TICKETS_CATEGORY = 'Book-Extras';
const TRAVEL_AGENCY_OPTIONS = 'Book-TravelAgencyOption';
const TRAVEL_AGENCY_SELECT = 'Book-TravelAgencySelect';
const ABANDON_BASKET_SHOWN = 'abandonBasketShown';
const ABANDON_BASKET_HIDDEN = 'abandonBsketHidden';
const ABANDON_BASKET_SENT = 'abandonBasketSignup';
const AGENCY_SUB_ID = 'Book-ExternalSubId';
const PAYMENT_CATEGORY = 'Book-Payment';
const BOOKING_GUESTS = 'Book-Guests';
const BOOKING_CONFIRM = 'Book-Confirm';
const VOUCHER = 'Book-Voucher';

const convertFieldName = name => ({
  title: 'Title',
  email: 'Email',
  firstName: 'First name',
  lastName: 'Last Name',
  customerCountry: 'Country',
  city: 'City',
  street: 'Street name',
  streetNumber: 'Street Number',
  floor: 'Floor',
  additionalAddress: 'Additional Address',
  zipCode: 'Postal code',
  phone: 'Phone number',
  additionalPhone: 'Additional phone number',
})[name] || name;

let firstInteract = true;

function createAnalyticLogger() {
  return ({getState}) => next => (action) => {
    if (!window.ga || !window.ga.getAll || !window.ga.getAll()[0]) {
      return next(action);
    }
    // @todo As it is very dirty hack, it should be fixed somehow.
    // GMT create GA tracker with custom name and I need it to send events.
    const trackerName = window.ga.getAll()[0].get('name');
    const currentState = getState();
    const returnValue = next(action);
    const newState = getState();

    /* eslint-disable default-case */
    switch (action.type) {
      case types.UPDATE_CUSTOMER_INFO: {
        if (['customerCountry', 'city', 'zipCode', 'title'].indexOf(action.payload.propertyName) !== -1) {
          window.ga(`${trackerName}.send`,
            'event',
            CUSTOMER_INFORMATION_CATEGORY,
            convertFieldName(action.payload.propertyName),
            action.payload.value);
        }
        else {
          window.ga(
            `${trackerName}.send`,
            'event',
            CUSTOMER_INFORMATION_CATEGORY,
            convertFieldName(action.payload.propertyName),
            'ok'
          );
        }
        break;
      }
      case types.UPDATE_EXTRA_SERVICES: {
        window.ga(`${trackerName}.send`,
          'event',
          SERVICES_CATEGORY,
          action.payload.serviceId,
          `${action.payload.value}`);
        const service = currentState.orderAppState.services.filter(s => s.serviceId === action.payload.serviceId)[0];
        const updatedService = newState.orderAppState.services.filter(s => s.serviceId === action.payload.serviceId)[0];
        const trackingEvent = updatedService.unitCount > service.unitCount ? 'productAddToCart' : 'productRemoveFromCart';

        const productsData = {
          products: [{
            name: updatedService.name,
            id: action.payload.serviceId,
            price: updatedService.unitPrice.amount,
            quantity: Math.abs(service.unitCount - updatedService.unitCount),
          }],
        };

        if (trackingEvent === 'productAddToCart') {
          window.dataLayer.push({
            event: trackingEvent,
            ecommerce: {
              currencyCode: updatedService.unitPrice.currencyCode,
              add: productsData,
            },
          });
        }
        else {
          window.dataLayer.push({
            event: trackingEvent,
            ecommerce: {
              currencyCode: updatedService.unitPrice.currencyCode,
              remove: productsData,
            },
          });
        }

        firstInteract = true;
        break;
      }
      case types.UPDATE_TICKETS: {
        window.ga(`${trackerName}.send`,
          'event',
          TICKETS_CATEGORY,
          action.payload.serviceId,
          `${action.payload.value}`);
        const ticket = currentState.orderAppState.services.filter(t => t.serviceId === action.payload.serviceId)[0];
        const updatedTicket = newState.orderAppState.services.filter(t => t.serviceId === action.payload.serviceId)[0];
        const trackingEvent = updatedTicket.unitCount > ticket.unitCount ? 'productAddToCart' : 'productRemoveFromCart';

        const productsData = {
          products: [{
            id: action.payload.serviceId,
            price: updatedTicket.unitPrice.amount,
            quantity: Math.abs(ticket.unitCount - updatedTicket.unitCount),
          }],
        };

        if (trackingEvent === 'productAddToCart') {
          window.dataLayer.push({
            event: trackingEvent,
            ecommerce: {
              currencyCode: updatedTicket.unitPrice.currencyCode,
              add: productsData,
            },
          });
        }
        else {
          window.dataLayer.push({
            event: trackingEvent,
            ecommerce: {
              currencyCode: updatedTicket.unitPrice.currencyCode,
              remove: productsData,
            },
          });
        }

        firstInteract = true;
        break;
      }
      case types.UPDATE_AGENCY_MESSAGE: {
        window.ga(`${trackerName}.send`,
          'event',
          TRAVEL_AGENCY_OPTIONS,
          'userMessage',
          action.payload);
        break;
      }
      case types.UPDATE_ORDER_TYPE: {
        window.ga(`${trackerName}.send`,
          'event',
          TRAVEL_AGENCY_OPTIONS,
          'orderType',
          action.payload);
        break;
      }
      case types.UPDATE_AGENCY_USER_ID: {
        window.ga(`${trackerName}.send`,
          'event',
          TRAVEL_AGENCY_OPTIONS,
          'userId',
          action.payload);
        break;
      }
      case types.UPDATE_AGENCY_SUB_ID: {
        window.ga(`${trackerName}.send`,
          'event',
          AGENCY_SUB_ID,
          'subId',
          action.payload);
        break;
      }
      case types.SELECT_PAYMENT_TYPE: {
        window.ga(`${trackerName}.send`,
          'event',
          PAYMENT_CATEGORY,
          'installments',
          action.payload ? 'one installment' : 'two installments');
        break;
      }
      case types.SELECT_PAYMENT_OPTION: {
        window.ga(`${trackerName}.send`,
          'event',
          PAYMENT_CATEGORY,
          'paymentOption',
          action.payload);
        window.dataLayer.push({
          event: 'checkoutStep',
          ecommerce: {
            currencyCode: newState.orderAppState.bookingPrice.currencyCode,
            checkout: {
              actionField: {
                step: 3,
                option: action.payload,
              },
              products:
                newState.orderAppState.bookingPrice.lineItems
                  .map(s => ({
                    id: s.serviceId,
                    price: s.unitPrice.amount,
                    quantity: s.unitCount,
                  })),
            },
          },
        });
        break;
      }
      case types.ACCEPT_TERMS: {
        window.ga(`${trackerName}.send`,
          'event',
          BOOKING_CONFIRM,
          'terms and conditions',
          '1');
        break;
      }
      case types.UPDATE_AGENCY_NUMBER: {
        window.ga(`${trackerName}.send`,
          'event',
          TRAVEL_AGENCY_SELECT,
          'agencyNumber',
          action.payload);
        break;
      }
      case types.UPDATE_SALES_CHANNEL: {
        window.ga(`${trackerName}.send`,
          'event',
          TRAVEL_AGENCY_SELECT,
          'salesChannel',
          action.payload);

        if (action.payload === WEB) {
          window.ga(`${trackerName}.send`,
            'event',
            TRAVEL_AGENCY_SELECT,
            'agencyNumber',
            '-1');
        }

        break;
      }
      case types.UPDATE_VOUCHER_CODE: {
        window.ga(`${trackerName}.send`,
          'event',
          VOUCHER,
          'voucher-code',
          action.payload);
        break;
      }
      case types.UPDATE_GUEST_OPTIONS: {
        window.ga(`${trackerName}.send`,
          'event',
          BOOKING_GUESTS,
          action.payload.propertyName,
          `${action.payload.value}`);
        /* eslint-disable array-callback-return, no-param-reassign */
        // We iterate over array elements, which are objects and using reference we set some props.
        window.dataLayer.map(function(item) {
          if (item.hasOwnProperty('event') && item.event === this.target) {
            if (this.key === 'adults' && item.hasOwnProperty('numberTotalAdults')) {
              item.numberTotalAdults = `${this.value}`;
            }
            if (this.key === 'children' && item.hasOwnProperty('numberTotalKids')) {
              item.numberTotalKids = `${this.value}`;
            }
          }
        },
        {
          target: 'checkoutStep',
          key: action.payload.propertyName,
          value: action.payload.value,
        });
        break;
      }
      case types.FIRE_PAY_BUTTON_CLICK: {
        window.ga(`${trackerName}.send`,
          'event',
          BOOKING_CONFIRM,
          'Pay now',
          '1');
        break;
      }
      case types.INTERACT_CUSTOMER_INFO: {
        if (firstInteract) {
          window.dataLayer.push({
            event: 'checkoutStep',
            ecommerce: {
              currencyCode: newState.orderAppState.bookingPrice.currencyCode,
              checkout: {
                actionField: {
                  step: 2,
                },
                products:
                  newState.orderAppState.bookingPrice.lineItems
                    .map(s => ({
                      id: s.serviceId,
                      price: s.unitPrice.amount,
                      quantity: s.unitCount,
                    })),
              },
            },
          });
          firstInteract = false;
        }
        break;
      }
      // Abandon basket
      case types.CUSTOMER_LEAVE: {
        window.dataLayer.push({
          event: ABANDON_BASKET_SHOWN,
        });
        break;
      }
      case types.HIDE_ABANDON_BASKET: {
        window.dataLayer.push({
          event: ABANDON_BASKET_HIDDEN,
        });
        break;
      }
      case types.SEND_ABANDON_BASKET: {
        window.dataLayer.push({
          event: ABANDON_BASKET_SENT,
          email: sha256(action.payload.customer.abandonEmail),
        });
        break;
      }
    }

    return returnValue;
  };
}

export default createAnalyticLogger();
